svg4everybody();


$(function () { 


	// Mobile Menu 
	// ---------------------------------------------- 
	function mobileMenu() {
		var mmNavbar = $('.navbar'),
			mmClose = $('.navbar__close'),
			mmOverlay = $('.navbar-overlay');

		$('._n-toggle ').on('click', function () {
			$('._n-toggle.burger').toggleClass('_active')
			mmNavbar.toggleClass('_open');
			mmOverlay.toggleClass('_show')
			$('html').toggleClass('lock')
			return false;
		})

	}
	mobileMenu();

	// Filter Menu 
	// ---------------------------------------------- 
	function mobileFilter() {
		var ffFilter = $('.filter'),
			ffClose = $('.filter__close'),
			ffOverlay = $('.filter-overlay');

		$('._f-toggle ').on('click', function () {
			
			ffFilter.toggleClass('_open');
			ffOverlay.toggleClass('_show')
			$('html').toggleClass('lock')
			return false;
		})

	}
	mobileFilter();

	// Search Open
	// ---------------------------------------------- 

	$('._open-search').on('click', function () {
		$('.nav-top__item').hide()
		$('._search-block').show();
		return false;
	})

	$(document).click( function(event){
		if( $(event.target).closest("._search-block").length ) 
		return;
		$("._search-block").hide()
		$('.nav-top__item').show()
		event.stopPropagation();
	});


	// Accordion 
	// ---------------------------------------------- 
	$('._ac__navitem').on('click', function(){
		var el = $(this);
		var elNext = $(this).next();
		$(this).parents('._ac').find('._ac__navitem').not(el).removeClass('_active')
		$(this).parents('._ac').find('._ac__item').not(elNext).slideUp(200)
		el.next('._ac__item').slideToggle(200);
		el.toggleClass('_active');
		return false;
	});


	// Selectbox
	// ---------------------------------------------- 
	 function selectbox() {
      $('._sel-btn').on('click', function () {
         $('._sel').not($(this).parents('._sel')).removeClass('opened')
         $('._sel-drop').not($(this).parents('._sel').find('._sel-drop')).slideUp(200)

         $(this).parents('._sel').toggleClass('opened');
         $(this).parents('._sel').find('._sel-drop').slideToggle(200);

         return false;
      })

      $('._sel li').on('click', function () {
         var thisElelmentText = $(this).html();
         $(this).parents('._sel').find('._sel-btn span').html(thisElelmentText);
         $(this).parents('._sel').removeClass('opened')
         $(this).parents('._sel').find('._sel-drop').slideUp(200);
         return false;
      })
   }
   selectbox();

   function selectboxHide() {
      $(document).click(function (event) {
         if ($(event.target).closest("._sel").length)
         return;
         $("._sel").removeClass("opened");
         $("._sel-drop").slideUp(200);
         event.stopPropagation();
      });
   }
   selectboxHide();

	// magnificPopup 
	// ---------------------------------------------- 
	if ($(".open-popup-link").length > 0) {
		$('.open-popup-link').magnificPopup({
			type: 'inline',
			midClick: true,
			removalDelay: 200,
			callbacks: {
		    beforeOpen: function() {
		       this.st.mainClass = this.st.el.attr('data-effect');
		    }
		  },
		});
	}
	$('._popup-close').on('click', function () {
		$.magnificPopup.close();
	})
	

	// Swiper Slider
	// ---------------------------------------------- 
	if ($('.cards-swiper').length) {
		var bambreakpoint = window.matchMedia( '(max-width:767px)' );
		var cardsSwiper;

		var breakpointChecker = function() {

		 if ( bambreakpoint.matches === true ) {
		  if ( cardsSwiper !== undefined ) cardsSwiper.destroy( true, true );
		  return;
		   } else if ( bambreakpoint.matches === false ) {

		     return enableSwiper();
		   }
		};


		var enableSwiper = function() {
		 cardsSwiper = new Swiper('.cards-swiper .swiper-container', {
			loop: true,
			slidesPerView: 4,
			spaceBetween: 20,
			watchOverflow: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			navigation: {
				nextEl: '.cards-swiper-next',
				prevEl: '.cards-swiper-prev',
			},
			breakpoints: {
				100: {
					slidesPerView: 2,
					spaceBetween: 10,
				},
				480: {
					slidesPerView: 3,
					
				},
				
				768: {
					slidesPerView: 4,
					spaceBetween: 20,
					
				},

			}
		 });

		};

		bambreakpoint.addListener(breakpointChecker);
		breakpointChecker();

		
	};

	if ($('.cards-more-swiper').length) {
		 var cardsMoreSwiper = new Swiper('.cards-more-swiper .swiper-container', {
			loop: true,
			slidesPerView: 4,
			spaceBetween: 20,
			watchOverflow: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			navigation: {
				nextEl: '.cards-more-swiper-next',
				prevEl: '.cards-more-swiper-prev',
			},
			pagination: {
				el: ".cards-more-swiper-pagination",
				clickable: true,
			},
			breakpoints: {
				100: {
					slidesPerView: 2,
					spaceBetween: 10,
				},
				480: {
					slidesPerView: 3,
				},
				
				768: {
					slidesPerView: 4,
					spaceBetween: 20,
					
				},

			}
		 });

	};
	if ($('.card-swiper-thumb').length) {
		window.cardSwiperThumb = new Swiper('.card-swiper-thumb .swiper-container', {
			
			loop: false,
			slidesPerView: 6,
			spaceBetween: 0,
			initialSlide: 0,
			watchOverflow: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			
			// slideToClickedSlide: true,
			// loopedSlides: 3,
			direction: "vertical",
			navigation: {
				nextEl: '.card-swiper-thumb-next',
				prevEl: '.card-swiper-thumb-prev',
			},
			pagination: {
				el: ".card-swiper-thumb-pagination",
				clickable: true,
			},
			breakpoints: {
				100: {
					slidesPerView: 'auto',
					spaceBetween: 10,
					direction: "horizontal",
				},

				1200: {
					slidesPerView: 5,
					spaceBetween: 0,
					direction: "vertical",
				},
				
				1500: {
					slidesPerView: 6,
				},

			}
		 });

   // Direct click handler for thumbnails to ensure sync with main swiper
   $(document).on('click', '.card-swiper-thumb .swiper-slide', function(e) {
     e.stopPropagation();
     var $this = $(this);
     var $wrapper = $this.closest('.swiper-wrapper');
     var index = $wrapper.children('.swiper-slide').index($this);
     if (typeof window.cardSwiper !== 'undefined' && index >= 0) {
       window.cardSwiper.slideTo(index, 300);
     }
   });

	};
	if ($('.card-swiper').length) {
		 window.cardSwiper = new Swiper('.card-swiper .swiper-container', {
			loop: false,
			slidesPerView: 1,
			spaceBetween: 0,
			watchOverflow: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			centerInsufficientSlides: true,
			
			// loopedSlides: 3,
			pagination: {
				el: ".card-swiper-pagination",
				clickable: true,
			},
			thumbs: {
				swiper: window.cardSwiperThumb
			},
			breakpoints: {
				100: {
					slidesPerView: 'auto',
					spaceBetween: 15,
					loop: false,

				},

				480: {
					slidesPerView: 'auto',
					spaceBetween: 22,
					loop: false,
					
				},
				
				768: {
					slidesPerView: 1,
					spaceBetween: 0,
					
					
				},

			}
		 });
         $.slide_variant = function (index){
         	window.cardSwiper.slideTo(index, 0);
         }
		    $(document).on('change', '.product-form__variants', function () {
      var variantId = $(this).val();
      var productData = window.meta && window.meta.product;
      if (!productData) return;

      var variant = productData.variants.find(function(v){
         return v.id == variantId;
      });
      if (!variant || !variant.featured_image) return;

      // Extract filename from variant image URL for reliable matching
      var variantImageSrc = variant.featured_image.src.split('?')[0];
      var variantImageFile = variantImageSrc.split('/').pop().split('_')[0];

      $('.card-swiper .swiper-slide').each(function(index){
         var $img = $(this).find('.swiper-slide-img');
         var imgSrc = $img.attr('src') || '';
         var imgFile = imgSrc.split('/').pop().split('_')[0];

         if (imgFile && variantImageFile && imgFile === variantImageFile) {
            window.cardSwiper.slideTo(index, 300);
            // Force both Swipers to update after sliding
            setTimeout(function() {
               window.cardSwiper.update();
               if (typeof window.cardSwiperThumb !== 'undefined') {
                  window.cardSwiperThumb.update();
               }
            }, 350);
            return false;
         }
      });
   });
	};

	
});


	// Dynamic
	// data-da=calss, index(last, first), media
	// ---------------------------------------------- 

	var originalPositions = [];
	var daElements = document.querySelectorAll('[data-da]');
	var daElementsArray = [];
	var daMatchMedia = [];
	//Заполняем массивы
	if (daElements.length > 0) {
		var number = 0;
		for (var index = 0; index < daElements.length; index++) {
			var daElement = daElements[index];
			var daMove = daElement.getAttribute('data-da');
			if (daMove != '') {
				var daArray = daMove.split(',');
				var daPlace = daArray[1] ? daArray[1].trim() : 'last';
				var daBreakpoint = daArray[2] ? daArray[2].trim() : '767';
				var daType = daArray[3] === 'min' ? daArray[3].trim() : 'max';
				var daDestination = document.querySelector('.' + daArray[0].trim())
				if (daArray.length > 0 && daDestination) {
					daElement.setAttribute('data-da-index', number);
					//Заполняем массив первоначальных позиций
					originalPositions[number] = {
						"parent": daElement.parentNode,
						"index": indexInParent(daElement)
					};
					//Заполняем массив элементов 
					daElementsArray[number] = {
						"element": daElement,
						"destination": document.querySelector('.' + daArray[0].trim()),
						"place": daPlace,
						"breakpoint": daBreakpoint,
						"type": daType
					}
					number++;
				}
			}
		}
		dynamicAdaptSort(daElementsArray);

		//Создаем события в точке брейкпоинта
		for (var index = 0; index < daElementsArray.length; index++) {
			var el = daElementsArray[index];
			var daBreakpoint = el.breakpoint;
			var daType = el.type;

			daMatchMedia.push(window.matchMedia("(" + daType + "-width: " + daBreakpoint + "px)"));
			daMatchMedia[index].addListener(dynamicAdapt);
		}
	}
	//Основная функция
	function dynamicAdapt(e) {
		for (var index = 0; index < daElementsArray.length; index++) {
			var el = daElementsArray[index];
			var daElement = el.element;
			var daDestination = el.destination;
			var daPlace = el.place;
			var daBreakpoint = el.breakpoint;
			var daClassname = "_dynamic_adapt_" + daBreakpoint;

			if (daMatchMedia[index].matches) {
				//Перебрасываем элементы
				if (!daElement.classList.contains(daClassname)) {
					var actualIndex = indexOfElements(daDestination)[daPlace];
					if (daPlace === 'first') {
						actualIndex = indexOfElements(daDestination)[0];
					} else if (daPlace === 'last') {
						actualIndex = indexOfElements(daDestination)[indexOfElements(daDestination).length];
					}
					daDestination.insertBefore(daElement, daDestination.children[actualIndex]);
					daElement.classList.add(daClassname);
				}
			} else {
				//Возвращаем на место
				if (daElement.classList.contains(daClassname)) {
					dynamicAdaptBack(daElement);
					daElement.classList.remove(daClassname);
				}
			}
		}
		customAdapt();
	}

	//Вызов основной функции
	dynamicAdapt();

	//Функция возврата на место
	function dynamicAdaptBack(el) {
		var daIndex = el.getAttribute('data-da-index');
		var originalPlace = originalPositions[daIndex];
		var parentPlace = originalPlace['parent'];
		var indexPlace = originalPlace['index'];
		var actualIndex = indexOfElements(parentPlace, true)[indexPlace];
		parentPlace.insertBefore(el, parentPlace.children[actualIndex]);
	}
	//Функция получения индекса внутри родителя
	function indexInParent(el) {
		var children = Array.prototype.slice.call(el.parentNode.children);
		return children.indexOf(el);
	}
	//Функция получения массива индексов элементов внутри родителя 
	function indexOfElements(parent, back) {
		var children = parent.children;
		var childrenArray = [];
		for (var i = 0; i < children.length; i++) {
			var childrenElement = children[i];
			if (back) {
				childrenArray.push(i);
			} else {
				//Исключая перенесенный элемент
				if (childrenElement.getAttribute('data-da') == null) {
					childrenArray.push(i);
				}
			}
		}
		return childrenArray;
	}
	//Сортировка объекта
	function dynamicAdaptSort(arr) {
		arr.sort(function (a, b) {
			if (a.breakpoint > b.breakpoint) { return -1 } else { return 1 }
		});
		arr.sort(function (a, b) {
			if (a.place > b.place) { return 1 } else { return -1 }
		});
	}
	//Дополнительные сценарии адаптации
	function customAdapt() {
		//var viewport_width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	}

// ================================
// Dynamic Variant Option Handler
// Works for ANY option (Size, Plating, Color, Placement, or any new option)
// ================================
$(document).on('change', '.details__content input[type="radio"]', function(e){
  var optionName = $(this).data('option-name'); // e.g. "Plating", "Size", "Placement"
  if (!optionName) return;
  $(".select_" + optionName).val(e.target.value);
  $(".select_" + optionName).trigger("change");
  // Force Swiper to update after variant change
  setTimeout(function() {
    if (typeof window.cardSwiper !== 'undefined') {
      window.cardSwiper.update();
    }
    if (typeof window.cardSwiperThumb !== 'undefined') {
      window.cardSwiperThumb.update();
    }
  }, 100);
});

// Inject custom size properties into the product form
function injectCustomSizeProperties() {
  var $form = $('[data-product-form]');
  // Remove any previously injected properties
  $form.find('.custom-size-property').remove();
  
  // Only inject if custom size fields are visible and have values
  if ($('#customSizeFields').is(':visible')) {
    var fields = [
      { id: '#custom-full-height', name: 'properties[Full Height]' },
      { id: '#custom-bust', name: 'properties[Bust]' },
      { id: '#custom-waist', name: 'properties[Waist]' },
      { id: '#custom-hips', name: 'properties[Hips]' },
      { id: '#custom-shoulder', name: 'properties[Shoulder]' }
    ];
    
    var unit = $('input[name="properties[Unit]"]:checked').val() || 'Inches';
    var anyFilled = false;

    fields.forEach(function(field) {
      var val = $(field.id).val().trim();
      if (val) {
        // Try to parse as number for conversion
        // Check if val contains only numbers (and optionally a dot)
        // If user enters "38", we convert. If "38ish", we leave as is.
        var numVal = parseFloat(val);
        var isNumeric = !isNaN(numVal) && isFinite(val);

        if (isNumeric) {
           var convertedVal, convertedUnit;
           if (unit === 'Inches') {
              convertedVal = (numVal * 2.54).toFixed(1).replace(/\.0$/, ''); // Remove .0 if integer
              val = val + ' inches / ' + convertedVal + ' cm';
           } else {
              // CM to Inches
              convertedVal = (numVal / 2.54).toFixed(1).replace(/\.0$/, '');
              val = val + ' cm / ' + convertedVal + ' inches';
           }
        } else {
           // Not a pure number, just append the selected unit
           val = val + ' ' + (unit === 'Inches' ? 'inches' : 'cm');
        }

        $form.append('<input type="hidden" class="custom-size-property" name="' + field.name + '" value="' + val + '">');
        anyFilled = true;
      }
    });

    if (anyFilled) {
       $form.append('<input type="hidden" class="custom-size-property" name="properties[Unit]" value="' + unit + '">');
    }
  }
}

var sizePlaceholders = {
  'Inches': {
    '#custom-chest': 'e.g. 38 (inches)',
    '#custom-waist': 'e.g. 32 (inches)',
    '#custom-hips': 'e.g. 40 (inches)',
    '#custom-length': 'e.g. 28 (inches)',
    '#custom-shoulder': 'e.g. 17 (inches)',
    '#custom-sleeve': 'e.g. 24 (inches)'
  },
  'CM': {
    '#custom-chest': 'e.g. 97 (cm)',
    '#custom-waist': 'e.g. 81 (cm)',
    '#custom-hips': 'e.g. 102 (cm)',
    '#custom-length': 'e.g. 71 (cm)',
    '#custom-shoulder': 'e.g. 43 (cm)',
    '#custom-sleeve': 'e.g. 61 (cm)'
  }
};

function updateCustomSizePlaceholders(unit) {
  var placeholders = sizePlaceholders[unit];
  if (!placeholders) return;
  
  for (var selector in placeholders) {
    if (placeholders.hasOwnProperty(selector)) {
      $(selector).attr('placeholder', placeholders[selector]);
    }
  }
}

// Listener for Unit Toggle
$(document).on('change', 'input[name="properties[Unit]"]', function() {
  var unit = $(this).val();
  updateCustomSizePlaceholders(unit);
});

$(function() {
  var unit = $('input[name="properties[Unit]"]:checked').val() || 'Inches';
  updateCustomSizePlaceholders(unit);
});

$('.add_to_cart_btn').on('click', function(e){
  e.preventDefault();
  
  // Custom sizes are now optional, no validation required.

  injectCustomSizeProperties();
  $('.product-form__cart-submit').click();
});

// Also inject before the hidden form button is clicked directly
$('.product-form__cart-submit').on('click', function(){
  // injectCustomSizeProperties(); // Disabled to avoid duplicate properties
});

$(function(){
	$fixedcard = $('.card-panel-fixed');
	$h = $('.card-main__buttons').length ? $('.card-main__buttons').offset().top + 42 : 0;
 
	$(window).scroll(function(){
		if ($(window).scrollTop() > $h) {
			$fixedcard.removeClass('hidden');
		} else {
			$fixedcard.addClass('hidden');
		}
	});
});

// Ahtung for USA
$(function(){
    $.get("http://ipinfo.io", function(response) {
        if(response.country == "US") {
            $('.ahtung').addClass('ahtung_vis');
        } else {
            $('.ahtung2').addClass('ahtung_vis');
        }
    }, "jsonp");
});

$(window).on('load', function() {
    // ================================
    // Size Chart Modal (custom, no jQuery Modal library needed)
    // ================================
    $(document).on('click', '#whatsizeBtn', function(e) {
        e.preventDefault();
        $('#whatsizeModal').fadeIn(200);
        $('body').css('overflow', 'hidden');
    });

    $(document).on('click', '#whatsizeClose', function() {
        $('#whatsizeModal').fadeOut(200);
        $('body').css('overflow', '');
    });

    // Close on overlay click
    $(document).on('click', '#whatsizeModal', function(e) {
        if ($(e.target).is('#whatsizeModal')) {
            $('#whatsizeModal').fadeOut(200);
            $('body').css('overflow', '');
        }
    });

    // Close on Escape key
    $(document).on('keyup', function(e) {
        if (e.keyCode === 27 && $('#whatsizeModal').is(':visible')) {
            $('#whatsizeModal').fadeOut(200);
            $('body').css('overflow', '');
        }
        if (e.keyCode === 27 && $('#measurementGuideModal').is(':visible')) {
            $('#measurementGuideModal').fadeOut(200);
            $('body').css('overflow', '');
        }
    });

    // Measurement Guide Modal
    $(document).on('click', '#measurementGuideTrigger', function(e) {
        e.preventDefault();
        $('#measurementGuideModal').fadeIn(200);
        $('body').css('overflow', 'hidden');
    });

    $(document).on('click', '#measurementGuideClose', function() {
        $('#measurementGuideModal').fadeOut(200);
        $('body').css('overflow', '');
    });

    $(document).on('click', '#measurementGuideModal', function(e) {
        if ($(e.target).is('#measurementGuideModal')) {
            $('#measurementGuideModal').fadeOut(200);
            $('body').css('overflow', '');
        }
    });

    // Darling modal (keep existing behavior if jQuery Modal is available)
    if (typeof $.fn.modal === 'function') {
        console.log('jQuery Modal detected, initializing Darling modal');
        $('a[href="#darling"]').click(function(event) {
            event.preventDefault();
            $(this).modal({ fadeDuration: 150, closeText: '×' });
        });

        $('a[href="#signupform"]').click(function(event) {
            event.preventDefault();
            $(this).modal({ fadeDuration: 150, closeText: '×' });
        });

        if (!sessionStorage.firstVisit) {
            $('a[href="#darling"]').modal({ fadeDuration: 150, closeText: '×' });
            setTimeout(function() {
                sessionStorage.firstVisit = 1;
            }, 2000);
        }
    }
});

// Ahtung 3 c анимацией
$(function(){
  var ahIndex = 0;
  setInterval(function(){
    if (ahIndex == $('.ahtung3_item').length - 1) {
      ahIndex = 0;
    } else {
      ahIndex = ahIndex + 1;
    }
    $('.ahtung3_item').addClass('ahtung3_inactive');
    $('.ahtung3_item').eq(ahIndex).removeClass('ahtung3_inactive');
  }, 5000);
});

// Preorder всплывашка
$(function(){ 
  setInterval(function(){
    if ($(document).width() > 768) {
      $(".pre-order-custom").on("mouseover", function () {
         $(".widget--timeline-wrap").fadeIn();
      });
      $(".pre-order-custom").on("mouseleave", function () {
          $(".widget--timeline-wrap").fadeOut();
      });
    } else {
      $('body').click(function(evt){    
          if($(evt.target).is('.end-date')) {
              $(".widget--timeline-wrap").toggle();
          } else {
              $(".widget--timeline-wrap").hide();
          }
      });
    }

    var currentDate = $('.card-main__buttons .end-date').text().replace('Pre-Order ends on ', '');
    $('.preordate').text(currentDate);
  }, 3000);
});

/* ================================
   Variant → Swiper image sync
   (Color / Size / Variant change)
================================ */

function slideToVariantImage(variant) {
  if (!variant || !variant.featured_media || !window.cardSwiper) return;

  var imageId = variant.featured_media.id;

  $('#ProductSection- .swiper-slide[data-image-id]').each(function(index){
    if ($(this).data('image-id') == imageId) {
      window.cardSwiper.slideTo(index, 300);
      return false;
    }
  });
}

// Check if the selected variant is "Customized" and show/hide the fields accordingly
function checkCustomSizeVisibility(variant) {
  if (!variant) return;

  var isCustom = false;
  // Check if any option value is "Customized" (case-insensitive)
  for (var i = 1; i <= 3; i++) {
    var optValue = variant['option' + i];
    if (optValue && (
        optValue.toLowerCase() === 'customized' || 
        optValue.toLowerCase() === 'custom' || 
        optValue.toLowerCase() === 'made by measure'
      )) {
      isCustom = true;
      break;
    }
  }

  var $toggleWrapper = $('.custom-size-toggle');
  var $fieldsWrapper = $('#customSizeFields');

  if (isCustom) {
    // Hide the toggle link wrapper (optional, or keep it as a header)
    $toggleWrapper.hide(); 
    // Auto-expand/show the fields directly
    $fieldsWrapper.slideDown(300);
    $fieldsWrapper.find('input, select, textarea').prop('disabled', false);
    // Show promos - REMOVED (Always visible via CSS/HTML now)
    // $('#customSizePromos').slideDown(300);
  } else {
    $toggleWrapper.hide();
    $fieldsWrapper.slideUp(300);
    $fieldsWrapper.find('input, select, textarea').prop('disabled', true);
    // Hide promos - REMOVED (Always visible via CSS/HTML now)
    // $('#customSizePromos').slideUp(300);
  }
}

// Check visibility on load
$(window).on('load', function() {
  var $variantSelect = $('.product-form__variants');
  // Check both the select and the radio/swatch inputs
  var variantId = null;
  
  if ($variantSelect.length) {
     variantId = $variantSelect.val();
  }
  
  // If variantId is null, try to find checked radio input for variant
  if (!variantId) {
    var $checkedInput = $('input[name="id"]:checked');
    if ($checkedInput.length) {
      variantId = $checkedInput.val();
    }
  }

  if (variantId) {
     var productData = window.ProductJson_ || window.ProductJson_ || null;
     if (productData) {
       var variant = productData.variants.find(function(v){ return v.id == variantId; });
       checkCustomSizeVisibility(variant);
     }
  }
});

// Listen to variant select change (and radio buttons/single option selectors) for robust detection
$(document).on('change', '.product-form__variants, .details__content input[type="radio"], .single-option-selector', function () {
  // Small delay to allow theme.js to update the hidden select if needed
  setTimeout(function() {
    var variantId = $('.product-form__variants').val();
    
    // Fallback: if no value from select, try checked radio for ID (if exists)
    if (!variantId && $('input[name="id"]:checked').length) {
      variantId = $('input[name="id"]:checked').val();
    }

    // Fallback 2: data-product-form might have the current variant ID in a data attribute or similar? 
    // Usually theme.js updates .product-form__variants value.

    var productData = window.ProductJson_ || window.ProductJson_ || null;
    if (!productData || !variantId) return;

    var variant = productData.variants.find(function(v){
      return v.id == variantId;
    });

    if (variant) {
      slideToVariantImage(variant);
      checkCustomSizeVisibility(variant);
    }
  }, 50);
});

// ================================
// Custom Size Fields Toggle
// ================================
$(document).on('click', '#customSizeToggle', function(e) {
  e.preventDefault();
  var $customFields = $('#customSizeFields');
  
  if ($customFields.is(':visible')) {
    $customFields.slideUp(300);
    $customFields.find('input, select, textarea').prop('disabled', true);
    // Hide promos - REMOVED
    // $('#customSizePromos').slideUp(300);
  } else {
    $customFields.slideDown(300);
    $customFields.find('input, select, textarea').prop('disabled', false);
    // Show promos - REMOVED
    // $('#customSizePromos').slideDown(300);
  }
  
  // Toggle the link text
  var $link = $(this);
  var svgHTML = $link.find('svg')[0] ? $link.find('svg')[0].outerHTML : '';
  if ($customFields.is(':visible')) {
    $link.html(svgHTML + ' Hide custom size fields');
  } else {
    $link.html(svgHTML + ' Need Custom Size? Click here to enter your measurements');
  }
});



// ================================
// Product Description Tabs (Desktop)
// ================================
$(document).on('click', '.product-tabs__btn', function() {
  var tabId = $(this).data('tab');
  
  // Update active button
  $('.product-tabs__btn').removeClass('active');
  $(this).addClass('active');
  
  // Show corresponding panel
  $('.product-tabs__panel').removeClass('active');
  $('.product-tabs__panel[data-tab-panel="' + tabId + '"]').addClass('active');

  // Sync accordion toggles (in case of resize)
  $('.product-tabs__accordion-toggle').removeClass('active');
  $('.product-tabs__accordion-toggle[data-tab="' + tabId + '"]').addClass('active');
});

// ================================
// Product Accordion (Mobile)
// ================================
$(document).on('click', '.product-tabs__accordion-toggle', function() {
  var $this = $(this);
  var tabId = $this.data('tab');
  var $panel = $('.product-tabs__panel[data-tab-panel="' + tabId + '"]');

  if ($this.hasClass('active')) {
    // Collapse this panel
    $this.removeClass('active');
    $panel.slideUp(300, function() {
      $panel.removeClass('active').css('display', '');
    });
  } else {
    // Expand this panel (close others first)
    $('.product-tabs__accordion-toggle').removeClass('active');
    $('.product-tabs__panel').slideUp(300, function() {
      $(this).removeClass('active').css('display', '');
    });

    $this.addClass('active');
    $panel.addClass('active').hide().slideDown(300);
  }

  // Sync desktop tabs
  $('.product-tabs__btn').removeClass('active');
  $('.product-tabs__btn[data-tab="' + tabId + '"]').addClass('active');
});

// Size Chart link inside Size & Fit tab
$(document).on('click', '#sizeChartLink', function(e) {
  e.preventDefault();
  $('#whatsizeModal').fadeIn(200);
  $('body').css('overflow', 'hidden');
});

// ================================
// Size Chart: Inches / CM Toggle
// ================================
$(document).on('click', '.size-unit-btn', function() {
  var unit = $(this).data('unit');

  // Update active button
  $('.size-unit-btn').removeClass('active');
  $(this).addClass('active');

  if (unit === 'cm') {
    $('#sizeChartTable .val-inches').hide();
    $('#sizeChartTable .val-cm').show();
  } else {
    $('#sizeChartTable .val-cm').hide();
    $('#sizeChartTable .val-inches').show();
  }
});

// ================================
// Size Chart: Regional Size Dropdown (US / UK / EU)
// ================================
$(document).on('change', '#regionalSizeSystem', function() {
  var system = $(this).val(); // 'us', 'uk', or 'eu'

  // Hide all regional spans
  $('#sizeChartTable .reg-us, #sizeChartTable .reg-uk, #sizeChartTable .reg-eu').hide();

  // Show selected system
  $('#sizeChartTable .reg-' + system).show();
});

// ================================
// Size Chart: Row Click Highlight
// ================================
$(document).on('click', '#sizeChartTable tbody tr', function() {
  var $row = $(this);
  if ($row.hasClass('highlighted')) {
    $row.removeClass('highlighted');
  } else {
    $('#sizeChartTable tbody tr').removeClass('highlighted');
    $row.addClass('highlighted');
  }
});
